// utils
import React from "react";
import { useMatch } from "react-router-dom";
import Dialog from "../../components/dialog";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

// custom utils
import {
  getCurrentLanguage,
  getUrlPrefix,
  LANGUAGES,
} from "../../utils/langUtils";

// translations
import translation_cs from "./components/lang/cs.json";
import translation_en from "./components/lang/en.json";
import translation_de from "./components/lang/de.json";

// files

// page sections
import CybersecHero from "./components/cybersec-hero/cybersec-hero";
import CybersecContact from "./components/cybersec-contact/cybersec-contact";
import CybersecServices from "./components/cybersec-services/cybersec-services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { BtnFloating } from "../../components/btn/btn-floating";

/**
 * CYBERSEC page
 * Handles whole CYBERSEC page with form - language, required input check, POST to the server as multipart/form-data
 * @returns HTML element for CYBERSEC page with 3 CybersecServices
 */
export default function Index() {
  const match = useMatch("/:lang/*");
  let lang = match && match.params.lang ? match.params.lang : "";
  let translation = translation_cs;

  let language = getCurrentLanguage(lang);
  switch (language) {
    case LANGUAGES.Czech:
      translation = translation_cs;
      break;
    case LANGUAGES.English:
      translation = translation_en;
      break;
    case LANGUAGES.German:
      translation = translation_de;
      break;
  }

  // solves broken layout of some pages in build
  const [hasMounted, setHasMounted] = React.useState(false);
  const [open, setOpen] = React.useState(true);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }

  return (
    <>
      <Dialog
        show={open}
        onClose={() => setOpen(false)}
        buttonText={translation.dialog.button}
        redirectTo={getUrlPrefix(language) + "calculator/en18031"}
      >
        <div className="d-flex gap-4 align-items-center">
          <FontAwesomeIcon
            icon={faQuestionCircle}
            aria-hidden="true"
            className="font-divelit-plum w-fit-content d-none d-md-block"
            style={{ height: "6rem" }}
          />
          <div>
            <h5 className="header-extra-small font-divelit-plum">
              {translation.dialog.title1}
            </h5>
            <h5 className="header-extra-small font-divelit-plum-70">
              {translation.dialog.title2}
            </h5>
          </div>
        </div>
        <p className="paragraph-small pt-4">{translation.dialog.text}</p>
      </Dialog>
      <div className="fade-in-750">
        <CybersecHero></CybersecHero>
        <CybersecServices></CybersecServices>
        <CybersecContact></CybersecContact>
      </div>
      <BtnFloating label={translation.floating_button_aria_label} icon="faXmark" onClick={() => setOpen(true)}>
        <FontAwesomeIcon icon={faCalculator} className="fa-solid fa-x" />
      </BtnFloating>
    </>
  );
}
